import { Component, OnInit, Output, Input, ViewEncapsulation, OnChanges, SimpleChanges } from '@angular/core';
import { Person } from './model/person'
import { ActivatedRoute, Router } from '@angular/router';
import { PersonService } from './service/person.service';
import { SessionHelper } from "@src/app/helpers/sessionHelper";
import { Personorg } from './model/personorg';

import { UntilDestroy, untilDestroyed } from '@ngneat/until-destroy';

@UntilDestroy({ checkProperties: true })
@Component({
  selector: 'app-person',
  templateUrl: './person.component.html',
  styleUrls: ['./person.component.css']
})
export class PersonComponent implements OnInit, OnChanges {

toggleDisplay() {
  if(this.orgeditmember == 'visible'){
    this.orgeditmember = 'collapsed';
    this.searchorgimg = '~/assets/images/material-icons/arrow-down-ex.png';
  }else{
    this.orgeditmember = 'visible';
    this.searchorgimg = '~/assets/images/material-icons/arrow-up-ex.png';
  }
}
  @Input() modal:boolean;    
  @Output() person:Person;
  @Output() readonly:boolean = true;
  @Output() editstate:string = "";
  @Output() editicon:string ="edit";
  @Output() editmessage:string ="Click to Edit";
  @Output() editclass:string = "";
  @Output() editclassh6:string ="";
  @Output() editclasstextarea:string="";
  @Output() showSpinner:boolean;
  @Output() noinputfieldset:string="disabled";
  searchorgimg = '~/assets/images/material-icons/arrow-down-ex.png';
  orgeditmember = 'collapsed';
  timetosave:number = 0;
  @Input() saveperson:number;
  @Input() update:number;
  orgList:Personorg[];
  
  constructor(
    private route:ActivatedRoute,
    private personService: PersonService,
    private router: Router,
  ) {
      }

  ngOnInit() {
    this.showSpinner = true;
    this.person = new Person;
    this.orgList = [];
    if(this.route.snapshot.paramMap.get('personId')){
      this.personService.getPerson(this.route.snapshot.paramMap.get('personId')).pipe(untilDestroyed(this)).subscribe(pers => {
        this.person = pers;
        if(!pers.personId){
          this.router.navigate(['/person/'+this.route.snapshot.paramMap.get('personId')+'/add']);
        }
        this.personService.getPersonOrgs(pers.personId).pipe(untilDestroyed(this)).subscribe(orglist => {
          if(orglist.length >0){
            this.orgList = orglist;
            if(this.orgList.length == 1 && !this.person.defaultorg){
              this.person.defaultorg = this.orgList[0].organizationId
            }
          }else{
            this.orgList = [];
          }
        });
        SessionHelper.setPerson(JSON.stringify(this.mergeWithSessionPerson(this.person)));
        setTimeout(()=>{this.showSpinner = false;},100);
    },(error)=>{
      alert('ERROR: '+error.error);

    });
    }else{
      this.personService.getPerson(SessionHelper.getUserSub()).pipe(untilDestroyed(this)).subscribe(pers => {
        this.person = pers;
        if(!pers.personId){
          this.router.navigate(['/person/'+SessionHelper.getUserSub()+'/add']);
        }
        this.personService.getPersonOrgs(pers.personId).pipe(untilDestroyed(this)).subscribe(orglist => {
          if(orglist.length >0){
          this.orgList = orglist;
          if(this.orgList.length == 1 && !this.person.defaultorg){
            this.person.defaultorg = this.orgList[0].organizationId
          }
        }else{
          this.orgList = [];
        }
        });
        SessionHelper.setPerson(JSON.stringify(this.mergeWithSessionPerson(this.person)));
        setTimeout(()=>{this.showSpinner = false;},100);
    },(error)=>{
      alert('ERROR: '+error.error);

    });
    }
    
    
    
  }
  ngOnChanges(changes: SimpleChanges): void {
    if(changes.saveperson && changes.saveperson.currentValue){
      this.onChange();
    }
    if(changes.update){
      setTimeout(()=>{
        this.person = JSON.parse(SessionHelper.getPerson());
      },800)
      
    }
  }
  onChange(){
      // Wait 1500 ms after last change before saving
     // this.timetosave = this.timetosave +1;
      //setTimeout(()=>{ 
       // this.timetosave = this.timetosave -1;
        //if(this.timetosave==0){
          this.personService.updatePerson(this.person).pipe(untilDestroyed(this)).subscribe(pers => {
            SessionHelper.setPerson(JSON.stringify(this.mergeWithSessionPerson(this.person)));
           // this.editstate = " - Your changes are saved!";
          });
        //}else{
       //   this.editstate = " - Saving...";
       // }
    //  } ,1500);
    
    
    
  }

  private mergeWithSessionPerson(incoming: Person): Person {
    try {
      const stored = JSON.parse(SessionHelper.getPerson());
      if (stored && stored.et_admin) {
        return { ...incoming, et_admin: stored.et_admin };
      }
    } catch (_e) {}
    return incoming;
  }

  // toggleReadonly(){
  //   if(this.readonly == true){
  //     this.readonly = false;
  //     this.editstate = " - Edit enabled";
  //     this.editicon = "save_alt";
  //     this.editmessage ="Click to Save Changes";
  //     this.editclass = "input-person-custom";
  //     this.editclassh6 ="data_custom_person";
  //     this.editclasstextarea ="textarea-person-custom";
  //     this.noinputfieldset ="";
  //   }else{
  //     this.editmessage ="";
  //     this.editicon = "edit";
  //     this.readonly = true;
  //     this.editstate = "";
  //     this.editclass="";
  //     this.editclassh6="";
  //     this.editclasstextarea ="";
  //     this.noinputfieldset ="disabled";
  //   }
  //   return this.readonly;
  // }
  
}
